import React from 'react';
import './App.css';
import UnAuth from './UnAuth'
import MainApp from './MainApp';
import { useAuth0 } from '@auth0/auth0-react';


function App() {
 // const [isLogged] = useContext(IsLoggedContext)
    const { isAuthenticated } = useAuth0();
    
  return isAuthenticated ? <MainApp /> : <UnAuth />
}
export default App;